// Pix "copia e cola" estático (BR Code do Banco Central), com o valor já preenchido.
// Sem integração: o app só monta o código; o dinheiro vai direto do banco da cliente para a chave do salão.
// Formato EMV: cada campo é ID (2) + tamanho (2) + valor; termina com CRC16-CCITT (0x1021, início 0xFFFF).

const field = (id: string, value: string) => `${id}${String(value.length).padStart(2, '0')}${value}`;

// o BR Code aceita só ASCII simples no nome e na cidade
const ascii = (s: string, max: number) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^A-Za-z0-9 .\-]/g, '').trim().slice(0, max);

export function crc16(payload: string): string {
  let crc = 0xffff;
  for (let i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8;
    for (let b = 0; b < 8; b++) crc = crc & 0x8000 ? ((crc << 1) ^ 0x1021) & 0xffff : (crc << 1) & 0xffff;
  }
  return crc.toString(16).toUpperCase().padStart(4, '0');
}

// dígitos verificadores do CPF: separa um CPF de um celular quando a chave vem só com números
export function isCpf(d: string): boolean {
  if (!/^\d{11}$/.test(d) || /^(\d)\1{10}$/.test(d)) return false;
  const dv = (n: number) => { let s = 0; for (let i = 0; i < n; i++) s += Number(d[i]) * (n + 1 - i); const r = (s * 10) % 11; return r === 10 ? 0 : r; };
  return dv(9) === Number(d[9]) && dv(10) === Number(d[10]);
}

// chave como o banco espera: celular com +55, CPF/CNPJ só números, e-mail em minúsculas, chave aleatória como está
export function normalizePixKey(raw: string): string {
  const k = raw.trim();
  if (k.includes('@')) return k.toLowerCase();
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(k)) return k.toLowerCase();
  const d = k.replace(/\D/g, '');
  if (k.startsWith('+')) return '+' + d;
  if (d.length === 14) return d; // CNPJ
  if (d.length === 11 && isCpf(d)) return d; // CPF
  if (d.length === 10 || d.length === 11) return '+55' + d; // celular ou fixo com DDD
  if ((d.length === 12 || d.length === 13) && d.startsWith('55')) return '+' + d;
  return k;
}

export function pixPayload(o: { key: string; name: string; city: string; amountCents?: number; txid?: string; description?: string }): string {
  const account = field('00', 'br.gov.bcb.pix') + field('01', normalizePixKey(o.key)) + (o.description ? field('02', ascii(o.description, 40)) : '');
  const txid = (o.txid ?? '***').replace(/[^A-Za-z0-9*]/g, '').slice(0, 25) || '***';
  const body = field('00', '01')
    + field('26', account)
    + field('52', '0000')
    + field('53', '986')
    + (o.amountCents ? field('54', (o.amountCents / 100).toFixed(2)) : '')
    + field('58', 'BR')
    + field('59', ascii(o.name, 25) || 'SALAO')
    + field('60', ascii(o.city, 15) || 'BRASIL')
    + field('62', field('05', txid))
    + '6304';
  return body + crc16(body);
}
